import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";

const products = [
  {
    id: 4001,
    name: "Super Asia Rice 25 kg bag",
    price: 8550,
   image: "/image/Groceries/superAsiaRice.jpg",
  },
  {
    id: 4002,
    name: "Sugar  50 kg bag",
    price: 7200,
    image: "/image/Groceries/Sugarbag502kg.jpg",
  },
  {
    id: 4003,
    name: "Shan Bombay biryani masala",
    price: 120,
    image: "/image/Groceries/shanbariyani.jpg",
  },
  {
    id: 4004,
    name: "Hafiz biryani masala",
    price: 180,
    image: "/image/Groceries/hafiz pulao masala.jpg",
  },
  {
    id: 4005,
    name: "Hafiz Foods Authentic Bannu Masala Mix for Biryani, Kabab, and Raita - 60g Pouch",
    price: 180,
    image: "/image/Groceries/Hafiz kabli pulao.jpg",
  },
  {
    id: 2006,
    name: "360° U-Shaped Baby Toothbrush | Soft Silicone Kids Oral Care & Teether Brush (Random Color)",
    price: 110,
    image: "/image/kids/U-Shaped Baby Toothbrush -Soft Silicone Kids Oral Care & Teether Brush.png",
  },
  {
    id: 2007,
    name: "Baby Spoon Feeder Silicone Bottle Feeding (Random Color)",
    price: 225,
    image: "/image/kids/Baby Spoon Feeder Silicone Bottle Feeding.jpg",
  },
  {
    id: 1008,
    name: "Next Nova Imported 10 Portable Air Cooler Fan – 3-in-1 Mini AC Desktop Humidifier 7-Color LED",
    price: 2200,
    image: "/image/shop/Portable Air Cooler Fan.jpg",
  },
  {
    id: 2009,
    name: "Baby Carrier, Ergonomic Baby Strap one Shoulder Labor-Saving Polyester Baby Half Wrapped Sling (Random Color)",
    price: 550,
    image: "/image/kids/Baby Carrier, Ergonomic Baby Strap one Shoulder Labor-Saving Polyester Baby Half Wrapped Sling (Random Color).jpg",
  },
  {
    id: 2010,
    name: "TECNO Plus GA-88 Portable AC/DC Table Fan – 12V Car & 220V Home Fan | Adjustable Mini Desk Fan for Office, Travel & Load Shedding | 8x6 Inches",
    price: 1071,
    image: "/image/kids/TECNO Plus GA-88 Portable AC-DC Table Fan.png",
  },
  {
    id: 2011,
    name: "Heavy Duty 9 In 1 MulPremium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan with Cute Fruit Design (Random Color & Box)",
    price: 585,
    image: "/image/kids/Premium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan.jpeg",
  },
  {
    id: 2012,
    name: "Premium Large Size Portable Handheld Fan – High-Speed USB Rechargeable Cooling Fan.jpeg",
    price: 850,
    image: "/image/kids/Portable Bladeless Neck Cooler – Hands-Free.jpeg",
  },
  {
    id: 1013,
    name: "Balebaily Long Wallet for Men & Women with Zipper Pocket - Black",
    price: 801,
    image: "/image/shop/Balebaily Long Wallet.png",
  },
  {
    id: 1014,
    name: "750ml Sports Water Bottle – Leakproof BPA-Free Gym & Fitness Drinking Bottle | Random Color",
    price: 975,
    image: "/image/shop/750ml Sports Water Bottle.jpeg",
  },
  {
    id: 1015,
    name: "Leakproof Replacement Lid Compatible with 40oz Tumblers | Random Color",
    price: 510,
    image: "/image/shop/Leakproof Replacement Lid Compatible.jpeg",
  },
  {
    id: 1016,
    name: "Peva Material Universal Electric Fan Dust Cover Prevent Aging Of Fan Blades Circular Electric Fan Sleeve Electric Fan Cover(random design )",
    price: 370,
    image: "/image/shop/Peva Material Universal Electric Fan Dust Cover.jpg",
  },
  {
    id: 1017,
    name: "Premium SZM 750ml Stainless Steel Water Bottle Leakproof | Random Color",
    price: 1751,
    image: "/image/shop/Premium SZM 750ml Stainless Steel Water Bottle Leakproof.jpeg",
  },
  {
    id: 1018,
    name: "ACNIX Anti Acne Face Wash Deep Cleansing Formula With Benzoyl Peroxide And Aloe Vera 120 ml",
    price: 910,
    image: "/image/shop/ACNIX Anti Acne Face Wash Deep Cleansing.png",
  },
  {
    id: 1019,
    name: "Acrylic Mirror Ayat ul Kursi Car Hanging Decor – Black & Golden Islamic Rear View Mirror Pendant | Size: 12 × 8",
    price: 480,
    image: "/image/shop/Acrylic Mirror Ayat ul Kursi Car Hanging Decor.jpeg",
  },
  {
    id: 1020,
    name: "Regal Steel Body Hot And Cold Water Cooler 10 Liter With Temperature Control And Elegant Floral Design",
    price: 8470,
    image: "/image/shop/Regal Steel Body Hot And Cold Water Cooler.png",
  },
 
];

const Groceries = () => {


  const navigate = useNavigate();
  return (
    <>
          <TopBar />
          <Navbar />
     
    <div className="min-h-screen bg-slate-100">
     


        {/* Hero Section */}
        <div className="bg-gradient-to-r from-green-600 via-emerald-600 to-green-700 text-white py-14">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-5xl font-bold mb-3">
              Grocery Store
            </h1>
            <p className="text-lg opacity-90">
              Fresh & Organic Daily Essentials Delivered to Your Doorstep
            </p>
          </div>
        </div>



      {/* Products Section */}
      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold mb-8 text-slate-800">
          Featured Products
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden group"
            >
              {/* Product Image */}
              <div className="h-64 bg-gray-50 p-4 flex items-center justify-center">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full w-full object-contain group-hover:scale-105 transition duration-300"
                />
              </div>

              {/* Product Details */}
              <div className="p-5">
                <h3 className="text-lg font-semibold text-slate-800 line-clamp-2 min-h-[56px]">
                  {product.name}
                </h3>

                <div className="flex items-center justify-between mt-4">
                  <span className="text-2xl font-bold text-orange-600">
                    Rs {product.price.toLocaleString()}
                  </span>
                </div>

                {/* <button className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300">
                  Add to Cart
                </button> */}
                <button
                        onClick={() => navigate(`/product/${product.id}`)}
                        className="w-full mt-5 bg-yellow-400 hover:bg-yellow-500 text-black font-semibold py-3 rounded-lg transition duration-300"
                        >
                        View Details
                        </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
     </>
  );
};

export default Groceries;






